(function () {
    "use strict";

    angular
        .module("app")
        .directive("sizeRangeEditor", ["$window", "$uibModal", "toaster", "QUtil", "PrototypeService", "UserService", sizeRangeEditor]);

    function sizeRangeEditor($window, $uibModal, toaster, qUtil, prototypeService, userService) {
        return {
            restrict: "E",
            link: function (scope, ele, attrs) {

                var modes = {
                    proto: "proto",
                    preset: "preset",
                    managePresets: "managePresets"
                };

                scope.load = function (id) {
                    if (id === scope.lastLoadedId) return;

                    scope.lastLoadedId = id;
                    //scope.displayData = [];
                    //scope.data = scope.data === undefined ? undefined : scope.data;
                    //scope.text = "";

                    scope.loadSizeRanges(id).then(function () {
                        scope.changeMode(modes.proto);
                    });
                };

                scope.save = function (form) {
                    if (form.$valid === false) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Please review all fields indicated in red.", timeout: 5000 });
                        return;
                    }

                    if (!scope.validateUniqueness()) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Duplicate region/width combination.", timeout: 5000 });
                        return;
                    }

                    toaster.clear();
                    scope.closeModal(form);

                    scope.protoData = scope.data = scope.displayData;
                    scope.text = scope.toString();
                };

                scope.clearValidation = function (form) {
                    form.$setPristine();
                    form.$setUntouched();
                    scope.hasChanges = false;
                };

                scope.validateUniqueness = function () {
                    var valid = true;

                    _.each(scope.displayData, function (d) {
                        d.notUnique = _.some(scope.displayData, function (s) {
                            return d !== s && d.RegionId === s.RegionId && d.WidthId === s.WidthId;
                        });

                        if (d.notUnique === true) {
                            valid = false;
                        }
                    });

                    return valid;
                };

                scope.loadSizeRanges = function (id) {
                    return prototypeService.getPrototypeSizeRanges(id).then(function (data) {
                        if (scope.data) //dont do anything if data is already there (Hidden Fields)
                            return;
                        scope.protoData = data;
                        scope.data = data;
                        scope.text = scope.toString();
                    });
                };

                scope.addRow = function (idx, a) {
                    var item = {
                        PrototypeSeasonalId: scope.prototypeSeasonalId
                    };

                    scope.displayData.splice(idx + a, 0, item);

                    scope.hasChanges = true;
                };

                scope.deleteRow = function (index) {
                    if ($window.confirm("This action will delete the current row. Do you want to continue?")) {
                        scope.displayData.splice(index, 1);

                        scope.hasChanges = true;

                        if (scope.displayData.length === 0 && scope.mode=='preset') {
                            scope.managePresets();
                        }
                    }
                };

                scope.removeAll = function() {
                    scope.data = [];
                    scope.displayData = [];
                    scope.text = "";
                    scope.hasChanges = true;
                    scope.onClose({ hasChanges: scope.hasChanges });
                };

                scope.changeMode = function (newMode) {
                    if (scope.mode === modes.proto)
                        scope.protoData = angular.copy(scope.displayData);
                    else if (scope.mode === modes.preset)
                        scope.editingPreset.Details = angular.copy(scope.displayData);

                    if (newMode === modes.proto)
                        scope.displayData = angular.copy(scope.protoData);
                    else if (newMode === modes.preset)
                        scope.displayData = angular.copy(scope.editingPreset.Details);
                    else
                        scope.displayData = [];

                    scope.newPreset = { Name: "", selected: null };

                    scope.mode = newMode;
                };

                scope.managePresets = function () {
                    scope.loadingPresets = true;
                    scope.changeMode("managePresets");
                    scope.loadPresets().then(function() {
                        scope.loadingPresets = false;
                    });
                };

                scope.cancelPresets = function () {
                    scope.changeMode("proto");
                    scope.loadPresets();
                };

                scope.editPreset = function (preset) {
                    scope.editingPreset = preset;
                    scope.changeMode("preset");
                };

                scope.editNewPreset = function () {
                    scope.editPreset({ Details: [{}] });
                };

                scope.loadPresets = function () {
                    return userService.getSizeRangePresets().then(function (data) {
                        scope.presets = data;
                    });
                };

                scope.applyPreset = function () {
                    if (scope.newPreset.selected) {
                        scope.displayData = _.map(scope.newPreset.selected.Details, function (m) {
                            return {
                                RegionId: m.RegionId,
                                SizeRange: m.SizeRange,
                                WidthId: m.WidthId,
                                PrototypeSeasonalId: scope.prototypeSeasonalId
                            };
                        });

                        scope.hasChanges = true;
                    }
                };

                scope.saveAsPreset = function (form) {
                    scope.newPreset.NameInvalid = !scope.newPreset.Name || scope.newPreset.Name.trim().length === 0;

                    if (scope.newPreset.NameInvalid === false) {
                        scope.editingPreset = {
                            Name: scope.newPreset.Name
                        };

                        scope.savePreset(form, function () { });
                    }
                };

                scope.savePreset = function (form, onComplete) {
                    if (form.$valid === false) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Please review all fields indicated in red.", timeout: 5000 });
                        return;
                    }

                    if (scope.displayData.length === 0) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "You must add at least one default value.", timeout: 5000 });
                        return;
                    }

                    if (!scope.validateUniqueness()) {
                        toaster.clear();
                        toaster.pop({ type: "error", title: "Error!", body: "Duplicate region/width combination.", timeout: 5000 });
                        return;
                    }

                    toaster.clear();
                    scope.clearValidation(form);

                    var preset = {
                        SizeRangePresetId: scope.editingPreset.SizeRangePresetId || 0,
                        Name: scope.editingPreset.Name,
                        Details: _.map(scope.displayData, function (m) {
                            return {
                                SizeRangePresetId: scope.editingPreset.SizeRangePresetId || 0,
                                SizeRangePresetDetailId: m.SizeRangePresetDetailId || 0,
                                RegionId: m.RegionId,
                                SizeRange: m.SizeRange,
                                WidthId: m.WidthId
                            };
                        })
                    };

                    if (!angular.isFunction(onComplete))
                        onComplete = scope.managePresets;

                    userService.saveSizeRangePresets(preset).then(function (result) {
                        if (result.IsSuccessful === true) {
                            toaster.pop({ type: "success", title: "Success!", body: "Presets saved successfully!", timeout: 5000 });

                            scope.loadPresets();

                            onComplete();

                            scope.newPreset = { Name: "", selected: null };
                        } else {
                            toaster.pop({ type: "error", title: "Error!", body: result.Message, timeout: 5000 });
                        }
                    }, function (msg) {
                        toaster.pop({ type: "error", title: "Error!", body: msg, timeout: 5000 });
                    });
                };

                scope.deletePreset = function (preset) {
                    if ($window.confirm("This action will permanently delete this preset. Do you want to continue?")) {
                        userService.deleteSizeRangePreset(preset.SizeRangePresetId).then(function () {
                            scope.managePresets();
                        });
                    }
                };

                scope.showFunc = function () {
                    if (scope.presetsOnly === true) {
                        scope.changeMode(modes.managePresets);
                    } else {
                        if (scope.data) {
                            scope.protoData = angular.copy(scope.data);
                        }

                        scope.changeMode(modes.proto);
                    }

                    scope.modal = $uibModal.open({
                        scope: scope,
                        templateUrl: templateUrl("app/directives/prototype/sizeRangeEditor-modal.directive.html"),
                        backdrop: "static",
                        size: "lg",
                        windowClass: "modal-bottom-options"
                    });
                    
                };

                scope.closeModal = function (form, cancel) {
                    scope.modal.close();

                    if (angular.isFunction(scope.onClose)) {
                        scope.onClose({ hasChanges: scope.hasChanges });
                    }

                    scope.hasChanges = form.$dirty;

                    //assign previous state
                    if (cancel)
                        scope.revert();
                };

                scope.revert = function () {
                    scope.displayData = angular.copy(scope.protoData);
                    scope.hasChanges = false;
                    scope.newPreset.selected = "";
                }

                scope.toString = function () {
                    var str = "";
                    for (var i in scope.protoData) {
                        var sr = scope.protoData[i];
                        if (sr.RegionId && sr.WidthId && sr.SizeRange) {
                            if (str.length > 0)
                                str = str + " ";

                            str = str + "[" + scope.regionName(sr.RegionId) + ";" + scope.widthName(sr.WidthId) + ";" + sr.SizeRange + "]";
                        }
                    }

                    return str;
                };

                scope.regionName = function (id) {
                    var region = _.find(scope.regions, function (r) { return r.RegionId === id; });
                    if (region) return region.RegionName;
                    return "";
                };

                scope.widthName = function (id) {
                    var width = _.find(scope.widths, function (r) { return r.WidthId === id; });
                    if (width) return width.Description;
                    return "";
                };

                scope.init = function () {
                    scope.data = scope.data === undefined ? undefined : scope.data;
                    scope.protoData = scope.displayData = scope.data;
                    scope.text = scope.text === undefined ? undefined : scope.text;
                    scope.presetsOnly = scope.presetsOnly === true;
                    scope.hasChanges = false;                    

                    qUtil.whenAll([
                        function () {
                            return prototypeService.getRegionList().then(function (data) {
                                scope.regions = data;
                            });
                        },
                        function () {
                            return prototypeService.getWidthList().then(function (data) {
                                scope.widths = data;
                            });
                        }
                    ]).then(function () {
                        if (scope.presetsOnly !== true) {
                            scope.load(scope.prototypeSeasonalId);
                        }

                        scope.loadPresets();
                    });

                    scope.$watch("prototypeSeasonalId", function (newValue) {
                        scope.load(newValue);
                    });
                };

                scope.init();

            },
            scope: { prototypeSeasonalId: "=", showFunc: "=?", readOnly: "=", data: "=?", displayData: "=?", protoData: "=?", text: "=?", hideSummary: "=?", onClose: "&?", presetsOnly: "=?" },
            templateUrl: templateUrl("app/directives/prototype/sizeRangeEditor-summary.directive.html")
        };
    }
})();

